// extracted by mini-css-extract-plugin
export default {"Main":"StickyAlert_Main__XEm76","Link":"StickyAlert_Link__dxfAy","CloseButton":"StickyAlert_CloseButton__ZXzii"};